import { router } from '../_helpers'
const jwt = require('jsonwebtoken')
import { jwtConfig } from '../_configs'
import { userService } from '../_helpers/user.service'

const user = {}
const userToken = localStorage.getItem('ben-token')
const currentTime = Date.now().valueOf() / 1000

// if there is a token, check if it is expired
// if it is expired, remove it
// if it is not, set the user information and permission levels
if(userToken) {
    if(userToken || userToken !== typeof undefined) {
        jwt.verify(userToken, jwtConfig.default.secret, function(err, decoded){
          if(!err) {
            if(decoded.exp < currentTime) {
              localStorage.removeItem('ben-token')
            }
          }
        })
      } else {

          jwt.verify(userToken, jwtConfig.default.secret, function(err, decoded) {
              user.name = decoded.name
          })
      }
}

const initialState = userToken ? { status: { loggedIn: true }, user } : { status: {}, user: null }

export const authentication = {
    namespaced: true,
    state: initialState,
    actions: {
        login({ commit }, { username, password}) {
            commit('loginRequest', { username })

            let loggedIn = userService.login(username, password)
                if(loggedIn != 'No') {
                    const theToken = localStorage.getItem('ben-token')
                    let loggedInUser = {}
                    if(theToken) {
                        jwt.verify(theToken, jwtConfig.default.secret, function(err, decoded) {
                            loggedInUser.name = decoded.name
                        })
                    }
                    commit('loginSuccess', loggedInUser.name)
                    router.push('/gifts')
                } else {
                    commit('loginFailure', 'Username or Password Incorrect')
                }

        },
        logout({ commit }, { action }) {
            userService.logout(action)
            commit('logout')
        },
        reLogIn({ commit }, { reload }) {
            const theToken = localStorage.getItem('ben-token')
            let loggedInUser = {}
            if(theToken) {
                jwt.verify(theToken, jwtConfig.default.secret, function(err, decoded) {
                    loggedInUser.name = decoded.name
                })
            }
            commit('loginSuccess', loggedInUser.name)
            if(!reload) {
                router.push('/gifts')
            }
        }
    },
    mutations: {
        loginRequest(state, user) {
            state.status = { loggingIn: true }
            state.user = user
        },
        loginSuccess(state, payload) {
            state.status = { loggedIn: true }
            state.user = payload
        },
        loginFailure(state) {
            state.status = {}
            state.user = null
        },
        logout(state) {
            state.status = {}
            state.user = null
        }
    }
}